// @ts-nocheck
// Standalone connection-status badge for the team-lead live feed. Kept out
// of the shared filter bar on purpose — the filter bar is about the date
// range (Leads/My Stats), a completely different axis from "is the socket
// connected right now", so it gets its own distinct, premium pill instead
// of being buried as plain text among filter controls.
import React from 'react';
import { WifiOff } from 'lucide-react';
import { LiveDot } from './teamUi';

export default function TeamLiveStatusBadge({ connected }) {
  if (connected) {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full bg-success/10 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-success">
        <LiveDot tone="good" />
        Live
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-warning/10 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-warning">
      <WifiOff size={11} />
      Reconnecting
    </span>
  );
}
